module.exports = __webpack_public_path__ + "img/logo-white.c019dc7f.png";